<div class="tableNoResults">
  <i class="tableNoResults-icon" svgImage [image]="'empty-state'"></i>
  <span class="tableNoResults-title">{{ 'GENERAL.NO_RESULTS' | translate }}</span>
  <span class="tableNoResults-description">{{ 'GENERAL.NO_RESULTS_DESCRIPTION' | translate }}</span>
</div>
